import { Component, ElementRef, OnInit, ViewChild, ViewChildren } from '@angular/core';
import { FormBuilder, FormGroup, FormControl, Validators, FormArray } from '@angular/forms';
import { ToastrService } from 'ngx-toastr'; // Alert message using NGX toastr
import { FirePracticalAssessmentService } from 'src/app/services/fire-practical-assessment-services/fire-practical-assessment.service';
import {  Router } from '@angular/router'; // ActivatedRoue is used to get the current associated components information.
import { MatDialog } from '@angular/material/dialog';
import { ModalsService } from '../../../modals/modals.service';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatTableDataSource } from '@angular/material/table';
import { tableValues } from 'src/app/models/tableValues';
import { SelectionModel } from '@angular/cdk/collections';
import {MatStepperModule} from '@angular/material/stepper';
import { FireActionItemService } from 'src/app/services/fire-action-items/fire-action-item.service';


export var B2Bvalue: boolean;
export var B2Cvalue: boolean;
export var showQ15to17: boolean;


export interface Dropdowns {
  value: number;
  name: string;
}

@Component({
  selector: 'app-operating-assessment',
  templateUrl: './operating-assessment.component.html',
  styleUrls: ['./operating-assessment.component.scss']
})
export class PracticalOperatingComponent implements OnInit {

  
  isLinear = false;
  panelOpenState = false;

  public assessmentForm: FormGroup; // Define  assessment form...in other one at the bottom of this list
  disableSelect = new FormControl(false);  
  selectedItems = [];
  hasUnitNumber = false;
  
  
 busiDemographics = [
    { name: 'Women-owned business' },
    { name: 'Minority-owned business' },
    { name: 'Immigrant-owned business' },
    { name: 'English as second language-owned business' },
    { name: 'COVID-19 negatively impacted business' },
    { name: 'None of the above or rather not say' },
  ];
  

  scaleChoices=[
    { value: 0, name: '1' },
    { value: 1, name: '2' },
    { value: 3, name: '3' },
    { value: 4, name: '4' },
    { value: 5, name: '5' },
  ]

  YesNoNotSure: Dropdowns[] = [
    { value: 1, name: 'Yes' },
    { value: 0, name: 'No or not sure' },
  ]

  YesNoNotSure2: Dropdowns[] = [
    { value: 1, name: 'Yes' },
    { value: 0, name: 'No or not sure' },
    { value: 1, name: 'Not applicable' },
  ]

  displayedColumns: string[] = ['name', 'doesNotExist', 'NeedsWork', 'GoodtoGo'];
  dataSource: MatTableDataSource<tableValues>;
  practicalBusinessPlanTable: tableValues[] = [
    {id: 'practicalBusiPlanExecSum', name: 'Executive Summary', value: 0},
    {id:'practicalBusiPlanMisVisGoal', name: 'Mission, Vision & Goal', value: 0}
  ]

  practicalBusiPlanArray = [
    {id: 'practicalBusiPlanExecSum', name: 'Executive Summary', value: 0},
    {id:'practicalBusiPlanMisVisGoal', name: 'Mission, Vision & Goal', value: 0}
  ]

  practicalHREmployeeRetention: Dropdowns[]=[
    { value: 1, name: 'Competitive Wages' },
    { value: 1, name: '401K and insurance benefits' },
    { value: 1, name: 'Company lunches, gatherings or outings' },
    { value: 1, name: 'Friendly onboarding process' },
    { value: 1, name: 'Company swag' },
    { value: 1, name: 'Commuter benefit' },
    { value: 1, name: 'Morally supportive environment' },
    { value: 1, name: 'Continuing Education supplementation/sponsorship' },
    { value: 1, name: 'Bonuses' },
    { value: 1, name: 'Other' },
    { value: 0, name: 'None of the above' }
  ]
  busiRegType = [
    {name: 'Not registered'},
    {name: 'Sole proprietor'},
    {name:'Single Member LLC'},
    {name: 'Multi Member LLC'},
    {name: 'Corp'},
    {name: 'S Corp'},
    {name: 'C Corp'},
    {name: 'B Corp'},
    {name: 'Non-profit'},
   ];

   practicalStrategyOperationsMethods = [
    {name: 'Brick and mortar location'},
    {name: 'E-commerce'},
    {name: 'Online platform (software, etc.)'},
    {name: 'Third party product placement/retail'},
    {name: 'Mobile operations/Pop up shops/food trucks/vending'},
    {name: 'None of the above'},
   ]

   practicalStrategyCustomerService: Dropdowns[] = [
    { value: 3, name: 'Consistently excellent' },
    { value: 2, name: 'Generally good'},
    { value: 1, name: 'Most often good' },
    { value: 0, name: 'Needs work' },
  ] 

  practicalStrategyCustomerEngagement: Dropdowns[] = [
    { value: 2, name: 'Highly engaged with lots of repeat customers' },
    { value: 1, name: 'Somewhat engaged'},
    { value: 0, name: 'No engagement at all' },
  ] 

   practicalLegalOpAgreement: Dropdowns[] = [
    { value: 1, name: 'Yes' },
    { value: 0, name: 'No' },
    { value: 1, name: 'No, single member owner' },
  ] 
  
  practicalLegalDisclaimers : Dropdowns[] = [
    { value: 1, name: 'Yes' },
    { value: 0, name: 'No' },
    { value: 1, name: 'I don`t need them' },
  ]

  practicalLegalIP : Dropdowns[] = [
     { value: 1, name: 'has patentable product(s), and it`s legally protected.' },
     { value: 0, name: 'has patentable product(s), but it`s not legally protected.' },
     { value: 1, name: 'doesn`t have patentable product(s).' },
  ]

    practicalFinanceSystem: Dropdowns[] = [
    { value: 1, name: 'Yes, I know how to use it' },
    { value: 0, name: 'Yes, but I don`t know how to use it' },
    { value: 0, name: 'No' },
  ]

  practicalMarketingBrand: Dropdowns[] = [
    { value: 2, name: 'It`s great' },
    { value: 1, name: 'I`m getting by' },
    { value: 0, name: 'I don`t have one' },
    
    
  ]
  practicalMarketingEffectiveness: Dropdowns[] = [
   { value: 2, name: 'Extremely comfortable' },
   { value: 1, name: 'Kind of comfortable' },
    { value: 0, name: 'Not at all comfortable' },
     { value: 0, name: 'I don`t market' },
  ]

  practicalMarketingWebsite: Dropdowns[] = [
     { value: 2, name: 'Yes, it`s good' },
     { value: 1, name: 'Yes, but its not effective or needs work' },
     { value: 0, name: 'No' },
   
  ]

  practicalMarketingNetworkMaterial: Dropdowns[] = [
    { value: 2, name: 'Yes, it`s good' },
    { value: 1, name: 'Yes, but it needs work' },
    { value: 0, name: 'No or I don`t network' }
  ]

  practicalMarketingEmailList: Dropdowns[] = [
    { value: 2, name: 'Yes, I use it frequently and effectively' },
    { value: 1, name: 'I have one but don`t use it, or don`t know how to' },
    { value: 0, name: 'I don`t have one' }
  ]

  practicalMarketingSocialMedia: Dropdowns[] = [
    { value: 3, name: 'It`s a major business driver' },
    { value: 2, name: 'It helps build awareness and engage existing customers' },
    { value: 1, name: 'I use it but there is little to no benefit' },
    { value: 0, name: 'I don`t use it' }
  ]

  revModel = [
    { name: 'Transactional one-time sale'},
    { name: 'Recurring installments or monthly payments' },
    { name: 'Licensing' },
    { name: 'Retail or Wholesale Markups' },
    { name: 'Affiliate or Commission' },
    { name: 'Charging Insurance'},
    { name: 'Product is free but services aren’t' },
    { name: 'Interest' },
    { name: 'Donations or Grants' },
    { name: 'Pay Per Use' },
  ];
  boolAnswer = [
    { name: 'Yes' }, 
    { name: 'No' }
  ];
  capitalSeeking = [
    { name: 'None' },
    { name: 'I`m not sure how much' },
    { name: 'Less than $10K' }, 
    { name: '$10K-$50K' }, 
    { name: '$50K-$100K' }, 
    { name: '$100K-$250K' }, 
    { name: '$250K+' }
  ];
  

  acceptTerms = [
    { name: 'I agree' }
  ];

  selection: any;
 

  //other one...didn't add get and set, or reset in this one
  
  @ViewChild('existingBase') q2: ElementRef;
  @ViewChild('operatingStrategyCustomerService') operatingStrategyCustomerService: ElementRef;
  @ViewChild('operatingStrategyCustomerEngagement') operatingStrategyCustomerEngagement: ElementRef;
  @ViewChild('operating2') operating2: ElementRef;
  @ViewChild('operating3') operating3: ElementRef;
  @ViewChild('operating4') operating4: ElementRef;
  @ViewChild('operating5') operating5: ElementRef;
  @ViewChild('operating6') operating6: ElementRef;
  @ViewChild('operating7') operating7: ElementRef;
  @ViewChild('operating8') operating8: ElementRef;
  @ViewChild('operatingMarketingEmailList') operatingMarketingEmailList: ElementRef;
  @ViewChild('operatingMarketingSocialMedia') operatingMarketingSocialMedia: ElementRef;
  @ViewChild('operating9') operating9: ElementRef;
  @ViewChild('operating10') operating10: ElementRef;
  @ViewChild('operating11') operating11: ElementRef;
  @ViewChild('operating12') operating12: ElementRef;
  @ViewChild('operating13') operating13: ElementRef;
  @ViewChild('operating14') operating14: ElementRef;
  @ViewChild('notoperating1') notoperating1:ElementRef;
  @ViewChild('notoperating2') notoperating2:ElementRef;
  @ViewChild('notoperating3') notoperating3:ElementRef;

  constructor(
    private fb: FormBuilder,
    public firePracticalAssessment: FirePracticalAssessmentService, //data in the other one
    private router: Router,
    public toastr: ToastrService,  // Toastr service for alert message
    public matDialog: MatDialog,
    public modal: ModalsService,
    public tooltip: MatTooltipModule,
    public fireActionItem: FireActionItemService,
  ) { }


  public teamMembersQuanCheck : number;
  public teamMemberHTMLVar: boolean = true;
  practicalID: any;
  
  public showAll: boolean = false;
  public buttonShow: boolean = true;
  public showBusiness: boolean = false;

  toggleStart() {
    this.buttonShow = !this.buttonShow;
    this.showBusiness = !this.showBusiness;
    this.showAll = !this.showAll;
  }

  // tslint:disable-next-line:typedef
  ngOnInit() {

    this.firePracticalAssessment.readAssessmentsList();  // Call ReadAssessmentsList() before main form is being called
    this.setPracticalSections();
    this.assessmenForm();              // Call assessment form when component is ready
    
  }

  setPracticalSections(){
    this.dataSource = new MatTableDataSource<tableValues>(this.practicalBusinessPlanTable);
    this.selection = new SelectionModel<tableValues>(true, []);
  }

 

  // tslint:disable-next-line:typedef
  assessmenForm() {
    this.assessmentForm = this.fb.group({
      busiName: [null, Validators.required],
      busiFirstName: [null, Validators.required],
      busiLastName: [null, Validators.required],
      busiEmail: [null, Validators.required],
      busiTelephone: [null, Validators.required],
      busiRegType: [null, Validators.required],
      practicalCompHistoryExistingCompany: null,
      practicalCompHistoryExistingCustomerBase: null,
      practicalStrategyOperationsMethods: [null, Validators.required],
      practicalStrategyCustomerService: null,
      practicalStrategyCustomerEngagement: null,
       practicalBusiPlanArray: this.fb.group({
        practicalBusiPlanExecSum: [null, Validators.required],
        practicalBusiPlanMisVisGoal: [null, Validators.required],
        practicalBusiPlanBusiSum: [null, Validators.required],
        practicalBusiPlanOfferDescrip: [null, Validators.required],
        practicalBusiPlanIndustryOverview: [null, Validators.required],
        practicalBusiPlanTargetMarket: [null, Validators.required],
        practicalBusiPlanMarketingSummary: [null, Validators.required],
        practicalBusiPlanSaleStrategy: [null, Validators.required],
        practicalBusiPlanTeamOverview: [null, Validators.required],
        practicalBusiPlanFinancialProjections: [null, Validators.required],
      }),
      practicalHiringPractices: this.fb.group({
        practicalHiringPracticesInterviewing: null,
        practicalHiringPracticesJobDescrp: null,
        practicalHiringPracticesOnboarding: null,
        practicalHiringPracticesHR: null,
      }),
     // practicalBusiPlanArray: [null, Validators.required],
      practicalHREmployeeRetention: null,
      practicalOpCRM: null,
      practicalOpSOP: null,
      practicalOpProductionProcess: null,
      practicalLegalOpAgreement: null,
      practicalLegalDisclaimers: null,
      practicalLegalIP: null,
      capitalSeeking: [null, Validators.required],
      practicalFinancePaymentSystem: null,
      practicalFinanceAccountingSystem: null,
      practicalFinance: this.fb.group({
        practicalFinanceStatements: [null, Validators.required],
        practicalFinanceTaxes: [null, Validators.required],
        practicalFinanceAccounting: [null, Validators.required],
        operatingFinancialCOGSExp: [null, Validators.required],
      }),
      practicalMarketingWebsite: null,
      practicalMarketingBrand: null,
      practicalMarketingEffectiveness: null,
      practicalMarketingNetworkMaterial: null,
      practicalMarketingEmailList: null,
      practicalMarketingSocialMedia: null,
      revModel: [null, Validators.required],
      acceptTerms: [null, Validators.required],
    });
  }

  ResetForm() { //add void as in other one?
    this.assessmentForm.reset();
  }



  onSubmit() {
    debugger
    const assessmentID = this.firePracticalAssessment.createAssessment({ ...this.assessmentForm.value})
      .then((id) => {
        console.log(id +"id")
        this.practicalID = id;
    console.log("practicalID", id);
    this.firePracticalAssessment.readSustainibleAssessment(this.practicalID);
      this.router.navigate(['operating-results/', this.practicalID]);
      }).catch((e) => {
        console.log("error", e);
      }); // Submit data using CRUD API//take out value? 
  }

  update(){
    console.log("Update function", this.practicalID);
    this.firePracticalAssessment.updateSustainibleeAssessment(this.practicalID, this.assessmentForm.value);
    this.firePracticalAssessment.readSustainibleAssessment(this.practicalID);
  }

  updateRedirect(){//not using
    console.log("Update function 2", this.practicalID);
    this.firePracticalAssessment.updateSustainibleeAssessment(this.practicalID, this.assessmentForm.value);
    this.firePracticalAssessment.readSustainibleAssessment(this.practicalID);
    //this.ResetForm();
    this.router.navigate(['operating-results/', this.practicalID]);
  }

  //busiDemographics: any;
  busiDemographicsList=[];

 

  handleQ2(event: { isUserInput: any; }, name: string) {
    if (event.isUserInput) {
      if (name === 'Yes') {
        this.q2.nativeElement.style.display = 'block';
        this.operatingStrategyCustomerService.nativeElement.style.display = 'block';
        this.operatingStrategyCustomerEngagement.nativeElement.style.display = 'block';
        this.operating2.nativeElement.style.display = 'block';
        this.operating3.nativeElement.style.display = 'block';
        this.operating4.nativeElement.style.display = 'block';
        this.operating5.nativeElement.style.display = 'block';
        this.operating6.nativeElement.style.display = 'block';
        this.operating7.nativeElement.style.display = 'block';
        this.operating8.nativeElement.style.display = 'block';
        this.operatingMarketingEmailList.nativeElement.style.display = 'block';
        this.operatingMarketingSocialMedia.nativeElement.style.display = 'block';
        this.operating9.nativeElement.style.display = 'block';
        this.operating10.nativeElement.style.display = 'block';
        this.operating11.nativeElement.style.display = 'block';
        this.operating12.nativeElement.style.display = 'block';
        this.operating13.nativeElement.style.display = 'block';
        this.operating14.nativeElement.style.display = 'block';
        this.notoperating1.nativeElement.style.display = 'none';
        this.notoperating2.nativeElement.style.display = 'none';
        this.notoperating3.nativeElement.style.display = 'none';
      }
      else if (name === 'No') {
        this.q2.nativeElement.style.display = 'none';
        this.operatingStrategyCustomerService.nativeElement.style.display = 'none';
        this.operatingStrategyCustomerEngagement.nativeElement.style.display = 'none';
        this.operating2.nativeElement.style.display = 'none';
        this.operating3.nativeElement.style.display = 'none';
        this.operating4.nativeElement.style.display = 'none';
        this.operating5.nativeElement.style.display = 'none';
        this.operating6.nativeElement.style.display = 'none';
        this.operating7.nativeElement.style.display = 'none';
        this.operating8.nativeElement.style.display = 'none';
        this.operatingMarketingEmailList.nativeElement.style.display = 'none';
        this.operatingMarketingSocialMedia.nativeElement.style.display = 'none';
        this.operating9.nativeElement.style.display = 'none';
        this.operating10.nativeElement.style.display = 'none';
        this.operating11.nativeElement.style.display = 'none';
        this.operating12.nativeElement.style.display = 'none';
        this.operating13.nativeElement.style.display = 'none';
        this.operating14.nativeElement.style.display = 'none';
        this.notoperating1.nativeElement.style.display = 'block';
        this.notoperating2.nativeElement.style.display = 'block';
        this.notoperating3.nativeElement.style.display = 'block';
      }
    }

  }
  

  tabNum = 0;
  nextTab() {
    if(this.tabNum < 5) {
      this.tabNum++;
    }
  }
  prevTab() {
    if(this.tabNum > 0) {
      this.tabNum--;
    }
  }

  hideQ15to17() {
    if(this.teamMembersQuanCheck == 1) {
      this.teamMemberHTMLVar = false;
      showQ15to17 = this.teamMemberHTMLVar;
    } else {
      this.teamMemberHTMLVar = true;
      showQ15to17 = this.teamMemberHTMLVar;
    }
  }

 
}
